exports.list = {
    path: '/penyusutan_biaya',
    name: 'penyusutan_biaya', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/penyusutan_biaya/List.vue"),
}
exports.show = {
    path: '/penyusutan_biaya/show/:no_kk',
    name: 'penyusutan_biaya_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/penyusutan_biaya/Show.vue"),
}